var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title mb-2"},[_c('strong',[_vm._v(_vm._s(_vm.selectedLecture.title))])]),_c('div',{key:_vm.selectedLecture.vimeoVideoId,staticClass:"vimeo-wrapper"},[_c('div',{attrs:{"id":"video-content"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }